// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GyBbG_Zte9B9DE6oaFWB{display:flex;flex-direction:column;padding-bottom:20px;gap:10px;width:80vw;min-height:200px;max-height:550px;height:80vh;min-width:300px;max-width:1000px}.GyBbG_Zte9B9DE6oaFWB .hb1UdOBNkYsihKohcO1P{width:100%;height:100%;display:flex;flex-direction:row;gap:1em}.GyBbG_Zte9B9DE6oaFWB .hb1UdOBNkYsihKohcO1P .Xhp0GnJ001KbbUj8i4I_{flex:1 1 30%}.GyBbG_Zte9B9DE6oaFWB .hb1UdOBNkYsihKohcO1P .quZ_ugGq4NgRwdXgYiqd{flex:1 1 70%;display:flex;flex-direction:column;align-items:center}.GyBbG_Zte9B9DE6oaFWB .hb1UdOBNkYsihKohcO1P .quZ_ugGq4NgRwdXgYiqd .SXqmVcMsDgJV8Fwd17z2{margin:auto;height:100%;display:flex;justify-content:center;flex-direction:column;align-items:center}.GyBbG_Zte9B9DE6oaFWB .hb1UdOBNkYsihKohcO1P .D6lg2jjzrZLefIjfGj0K{width:100%;height:100%;flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `GyBbG_Zte9B9DE6oaFWB`,
	"twoColumns": `hb1UdOBNkYsihKohcO1P`,
	"leftColumn": `Xhp0GnJ001KbbUj8i4I_`,
	"rightColumn": `quZ_ugGq4NgRwdXgYiqd`,
	"carouselItem": `SXqmVcMsDgJV8Fwd17z2`,
	"image": `D6lg2jjzrZLefIjfGj0K`
};
export default ___CSS_LOADER_EXPORT___;
